import React from 'react';
import { ArrowRight, Zap, Droplets } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-lime-500/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-amber-400/10 rounded-full blur-3xl animate-pulse delay-1000" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-orange-500/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pt-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-left space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center space-x-2 bg-amber-400/10 border border-amber-400/20 rounded-full px-4 py-2">
                <Zap className="w-4 h-4 text-amber-400" />
                <span className="text-amber-400 font-semibold text-sm">Fuel Your Hustle</span>
              </div>
              
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white leading-tight">
                Where Taste, Fashion
                <span className="block mt-2">
                  & Good <span className="text-amber-400">Energy</span> Meet
                </span>
              </h1>
            </div>

            <p className="text-xl text-gray-300 leading-relaxed max-w-xl">
              Juices • Shots • Tees • Mixed Drinks<br />
              Street culture meets clean energy. Orlando-rooted, hip-hop coded,
              built for those who move legendary.
            </p>

            <div className="grid sm:grid-cols-3 gap-4">
              <Button
                size="lg"
                className="bg-amber-400 hover:bg-amber-500 text-black font-bold px-6 py-6"
                onClick={() => document.getElementById('products').scrollIntoView({ behavior: 'smooth' })}
              >
                Order Juices
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-black font-bold px-6 py-6"
                onClick={() => document.getElementById('products').scrollIntoView({ behavior: 'smooth' })}
              >
                Shop Tees
              </Button>
              <Button
                size="lg"
                className="bg-lime-400 hover:bg-lime-500 text-black font-bold px-6 py-6"
                onClick={() => document.getElementById('subscriptions').scrollIntoView({ behavior: 'smooth' })}
              >
                Get $25 Sub
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center space-x-8 pt-4">
              <div className="flex items-center space-x-2">
                <Droplets className="w-5 h-5 text-lime-400" />
                <span className="text-sm text-gray-400">Real Juice, Real Energy</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 bg-lime-400 rounded-full" />
                <span className="text-sm text-gray-400">100% Natural</span>
              </div>
            </div>
          </div>

          {/* Right Content - Hero Image Gallery */}
          <div className="relative hidden lg:block">
            <div className="grid grid-cols-2 gap-4 relative z-10">
              <div className="aspect-square overflow-hidden rounded-xl shadow-xl product-tile-green">
                <img
                  src="https://customer-assets.emergentagent.com/job_drinkstack/artifacts/9xezkzvw_Green%20drinks.png"
                  alt="Green Power Vitamin Boost"
                  className="w-full h-full object-contain hover:scale-105 transition-transform duration-300 product-image product-image-sharp"
                />
              </div>
              <div className="aspect-square overflow-hidden rounded-xl shadow-xl product-tile-berry">
                <img
                  src="https://customer-assets.emergentagent.com/job_drinkstack/artifacts/fq3mktus_Berry%20blast.png"
                  alt="Berry Blast"
                  className="w-full h-full object-contain hover:scale-105 transition-transform duration-300 product-image product-image-sharp"
                />
              </div>
              <div className="aspect-square overflow-hidden rounded-xl shadow-xl product-tile-tropical">
                <img
                  src="https://customer-assets.emergentagent.com/job_drinkstack/artifacts/xllt07u7_Tropical%20Tangy.png"
                  alt="Tropical Tangy"
                  className="w-full h-full object-contain hover:scale-105 transition-transform duration-300 product-image product-image-sharp"
                />
              </div>
              <div className="aspect-square overflow-hidden rounded-xl shadow-xl product-tile-dark">
                <img
                  src="https://customer-assets.emergentagent.com/job_drinkstack/artifacts/325i67pr_Midnight%20Orchard.png"
                  alt="Midnight Orchard"
                  className="w-full h-full object-contain hover:scale-105 transition-transform duration-300 product-image product-image-sharp"
                />
              </div>
            </div>
            {/* Decorative Elements */}
            <div className="absolute -top-6 -right-6 w-40 h-40 bg-amber-400/20 rounded-full blur-2xl" />
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-lime-400/20 rounded-full blur-2xl" />
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/50 rounded-full" />
        </div>
      </div>
    </section>
  );
};